import { getList } from "@/api/dynamic";
import storage from "@/utils/storage";
export const pagedynamic = {
    //开启命名空间
    namespaced: true,
    //存储数据
    state: {
        infolist: [],
        menu: 0,
        flag: false,
        page: 1,
        count: 0,
        limit: 3,
    },
    //响应组件中加的动作
    actions: {
        getpage(context, value) {
            console.log(11111)
            console.log(context, value)
            console.log("--------------")
            context.commit("GETPAGE", value)
            console.log("--------------")
        }
    },
    //操作数据
    mutations: {
        GETPAGE(state, value) {
            console.log(22222)
            console.log(state, value)
            if (value.page) {
                state.page = value.page;
            }
            console.log(storage.get('Allnew'))
            
            let data = {
                menu: value.menu,
                p: value.page,
                limit: value.limit,
            }
            getList(data)
                .then((res) => {
                    console.log(res)
                    state.infolist = res.data;
                    state.count = res.totalRow;
                    state.flag = true;
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }

}


